import { AxiosReportLas, AxiosGlobalFilters } from '../config';
import qs from 'qs';
import {
  SendExcelReportPayload,
  SendPDFReportPayload,
  SendPDFSummaryReportPayload,
} from '../../../pages/Reports/Activities/types';
const ActivitiesServices = {
  validateLogin: login => {
    return AxiosReportLas({
      method: 'post',
      url: `/v1/Relatorios/ValidarEmailUsuario?login=${login}`,
    });
  },
  getActivitiesPlans: ({ companyId, unitId, systemIds /*inactivePlans */ }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: `/v1/planosatividades/ativos`,
      params: {
        empresaId: companyId,
        sistemasIds: systemIds,
        unidadeId: unitId,
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    });
  },
  sendExcelByEmail: ({
    login,
    site,
    listaSites,
    empresa,
    dataInicial,
    dataFinal,
    sistemas,
    planoAtividades,
    status,

    planosInativos,
  }: SendExcelReportPayload) => {
    return AxiosReportLas({
      method: 'post',
      url: '/v1/Relatorios/RelatorioAtividade',
      data: {
        login,
        site,
        empresa,
        dataInicial,
        dataFinal,
        sistemas,
        planoAtividades,
        status,
        listaSites,
        planosInativos,
      },
      headers: {
        'Content-Type': 'application/json',

        EmpresaId: empresa,
      },
    });
  },
  sendPDFByEmail: ({
    login,
    naoAgruparFotos,
    unidadeManutencao,
    empresa,
    dataPrevistaInicial,
    dataPrevistaFinal,
    dataRealizadaInicial,
    dataRealizadaFinal,
    sistemas,
    custos,
    materiaisUtilizados,
    assinaturas,
    medicoes,
    justificativaAtividadesNaoRealizadas,
    fotos,
    planoAtividades,
    status,
    umaAplicacaoPagina,
    fornecedores,
    executores,
    gruposAreas,
    subGrupoAreas,
    areas,
    tipoEquipamentos,
    planosInativos,
    equipmentos,
  }: SendPDFReportPayload) => {
    return AxiosReportLas({
      method: 'post',
      url: '/v1/Relatorios/RelatorioAtividadepdf',
      data: {
        login,
        email: login,
        naoAgruparFotos,
        unidadeManutencao,
        empresa,
        dataPrevistaInicial,
        dataPrevistaFinal,
        dataRealizadaInicial,
        dataRealizadaFinal,
        sistemas,
        custos,
        materiaisUtilizados,
        assinaturas,
        medicoes,
        justificativaAtividadesNaoRealizadas,
        fotos,
        planoAtividades,
        status,
        fornecedores,
        executores,
        gruposAreas,
        subGrupoAreas,
        areas,
        tipoEquipamentos,
        planosInativos,
        equipmentos,
        umaAplicacaoPagina,
      },
      headers: {
        'Content-Type': 'application/json',
        EmpresaId: empresa,
      },
    });
  },
  sendPDFSummaryByEmail: ({
    login,
    unidadeManutencao,
    naoAgruparFotos,
    empresa,
    dataPrevistaInicial,
    dataPrevistaFinal,
    dataRealizadaInicial,
    dataRealizadaFinal,
    sistemas,
    custos,
    materiaisUtilizados,
    assinaturas,
    medicoes,
    justificativaAtividadesNaoRealizadas,
    fotos,
    planoAtividades,
    status,

    fornecedores,
    executores,
    gruposAreas,
    subGrupoAreas,
    areas,
    tipoEquipamentos,
    equipmentos,
    planosInativos,
  }: SendPDFSummaryReportPayload) => {
    return AxiosReportLas({
      method: 'post',
      url: '/v1/Relatorios/RelatorioAtividadeResumido',
      data: {
        login,
        email: login,
        naoAgruparFotos,
        unidadeManutencao,
        empresa,
        dataPrevistaInicial,
        dataPrevistaFinal,
        dataRealizadaInicial,
        dataRealizadaFinal,
        sistemas,
        custos,
        materiaisUtilizados,
        assinaturas,
        medicoes,
        justificativaAtividadesNaoRealizadas,
        fotos,
        planoAtividades,
        status,
        fornecedores,
        executores,
        gruposAreas,
        subGrupoAreas,
        areas,
        tipoEquipamentos,
        equipmentos,
        planosInativos,
      },
      headers: {
        'Content-Type': 'application/json',

        EmpresaId: empresa,
      },
    });
  },
};

export { ActivitiesServices };
